import React, { useEffect, useRef, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import Tooltip from 'react-simple-tooltip';

import { ApexOptions } from 'apexcharts';
import { useAccount } from 'wagmi';

import { useGlobalContext } from '../../AppContext';
import { calculateColumnWidth, parseAmount, parseMoney, parsePercentage } from '../../utils/utils';
import { BigMenu } from '../../components/BigMenu';
import { Dropdown } from '../../components/Dropdown';
import { MyWalletData } from '../../components/MyWalletData';
import { donutOptions } from './graphData';

import './Dashboard.scss';

declare global {
  interface Window {
    width?: number;
  }
}
export function Dashboard() {
  const {
    tutorialCount,
    setTutorialCount,
    systemReady,
    demoMode,
    config,
    isMobile,
    hideMinimumToken,
    firstRun,
    wallets,
    nft,
  } = useGlobalContext();
  const { address: account } = useAccount();

  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const handleThemeChange = () => {
      const newTheme = document.body.classList.contains('dark') ? 'light' : 'dark';
      setTheme(newTheme);
    };

    handleThemeChange();

    const observer = new MutationObserver(handleThemeChange);
    const config = { attributes: true, attributeFilter: ['class'] };
    observer.observe(document.body, config);

    return () => {
      observer.disconnect();
    };
  }, []);
  const [showTable, setShowTable] = useState<JSX.Element>(<></>);
  const [donutGraphOptions, setDonutGraphOptions] = useState<ApexOptions>(donutOptions);
  const [donutGraphData, setDonutGraphData] = useState<number[]>([]);
  const [donutGraphTips, setDonutGraphTips] = useState<string[]>([]);

  const [top5List, setTop5List] = useState<any>();
  const [top5ListFilter, setTop5ListFilter] = useState<string>();

  const [gainerLoserFilter, setGainerLoserFilter] = useState<string>('portfolio');

  const [tableWalletFilter, setTableWalletFilter] = useState<string>();
  const [networkFilter, setNetworkFilter] = useState<string[]>([]);

  const [tutorial, setTutorial] = useState<string>('');

  //const [lineGraphOptions, setLineGraphOptions] = useState<ApexOptions>(lineOptions);
  //const [lineGraphData, setLineGraphData] = useState<{ name: string; data: number[] }[]>([]);
  const [tableData, setTableData] = useState<TableDataProps[]>([]);

  /*
  https://github.com/artlu99/alchemy-r2w3-week-9/blob/387163a2669b174adcd6b855978186b33f4ba96e/scripts/index.js

  https://tokenlists.org/token-list?url=https://tokens.coingecko.com/uniswap/all.json

  https://bsctokenlists.org/token-list?url=https://gateway.pinata.cloud/ipfs/QmdKy1K5TMzSHncLzUXUJdvKi1tHRmJocDRfmCXxW5mshS
  https://tokens.pancakeswap.finance/pancakeswap-extended.json

  https://api-polygon-tokens.polygon.technology/tokenlists/allTokens.tokenlist.json


  https://github.com/wbobeirne/eth-balance-checker
  */

  const [currentWidget, setCurrentWidget] = useState<number>(1);
  const moveLeft = () => {
    if (currentWidget > 1) {
      moveWidget1();
      setCurrentWidget(1);
    } else {
      moveWidget3();
      setCurrentWidget(3);
    }
  };
  const moveRight = () => {
    if (currentWidget < 3) {
      moveWidget3();
      setCurrentWidget(3);
    } else {
      moveWidget1();
      setCurrentWidget(1);
    }
  };

  const widgetRef1 = useRef<null | HTMLDivElement>(null);
  const widgetRef2 = useRef<null | HTMLDivElement>(null);
  const widgetRef3 = useRef<null | HTMLDivElement>(null);
  const moveWidget1 = () => {
    widgetRef1 &&
      widgetRef1.current &&
      widgetRef1.current.scrollIntoView({ block: 'nearest', inline: 'start' });
    if (document.getElementById('mobileSlider')) {
      document.getElementById('mobileSlider')?.setAttribute('class', 'mobile-slider');
      //document.getElementById('leftArrow').setAttribute('style', 'top:160px !important');
      //document.getElementById('rightArrow').setAttribute('style', 'top:160px !important');
    }
  };

  const moveWidget3 = () => {
    widgetRef3 &&
      widgetRef3.current &&
      widgetRef3.current.scrollIntoView({ block: 'nearest', inline: 'start' });
    if (document.getElementById('mobileSlider')) {
      document.getElementById('mobileSlider')?.setAttribute('class', 'mobile-slider autoHeight');
      //document.getElementById('leftArrow').setAttribute('style', 'top:230px !important');
      //document.getElementById('rightArrow').setAttribute('style', 'top:230px !important');
    }
  };

  // render graphs
  useEffect(() => {
    if (config && config.globalNetworks) {
      let emptyNetworkRatios = 0;

      if (config.globalNetworks && Object.keys(config.globalNetworks).length > 0) {
        Object.keys(config.globalNetworks).map((key: any) => {
          if (config.globalNetworks[key].ratio === 0.01) {
            emptyNetworkRatios += 0.01;
          }
        });
      }

      const donutDataTmp: number[] = [];
      let totalTmp = 0;
      if (config.globalNetworks && Object.keys(config.globalNetworks).length > 0) {
        Object.values(config.globalNetworks).map((item: any) => {
          if (item.ratio && !isNaN(item.ratio) && item.ratio >= 10) {
            totalTmp += item.ratio;
            donutDataTmp.push(item.ratio);
          }
        });
      }

      if (totalTmp > 0 && totalTmp < 100) {
        donutDataTmp.push(100 - totalTmp);
      }

      const donutLabelsTmp: string[] = [];
      const donutColorsTmp: string[] = [];
      const donutTipsTmp: any[] = [];
      const labelOthers: any[] = [];
      if (config.globalNetworks && Object.keys(config.globalNetworks).length > 0) {
        Object.keys(config.globalNetworks).map((key: any, index: number) => {
          if (
            config.globalNetworks[key].ratio &&
            !isNaN(config.globalNetworks[key].ratio) &&
            config.globalNetworks[key].ratio >= 10
          ) {
            if (false) donutLabelsTmp.push(config.globalNetworks[key].name);
            else {
              donutLabelsTmp.push(
                config.globalNetworks[key].name +
                  ' ' +
                  (config.globalNetworks[key].ratio - emptyNetworkRatios) +
                  '%',
              );
              emptyNetworkRatios = 0;
            }
            donutColorsTmp.push(config.globalNetworks[key].color);
            donutTipsTmp.push(
              `${config.globalNetworks[key].name} ${config.globalNetworks[key].ratio}%`,
            );
          } else if (
            config.globalNetworks[key].balance &&
            !isNaN(config.globalNetworks[key].balance) &&
            config.globalNetworks[key].balance > 0
          ) {
            labelOthers.push(
              <React.Fragment key={`k1-${index}`}>
                {config.globalNetworks[key].name} {config.globalNetworks[key].ratio}%
              </React.Fragment>,
            );
          }
        });
      } else {
        labelOthers.push(<React.Fragment key={`k1-0`}>Others 0%</React.Fragment>);
      }

      if (labelOthers && labelOthers.length > 0) {
        donutLabelsTmp.push('Others');
        donutColorsTmp.push('#ed19d8');
        donutTipsTmp.push(
          labelOthers.map((item, index) => (
            <React.Fragment key={`k2-${index}`}>
              {index > 0 && <br />}
              {item}
            </React.Fragment>
          )),
        );
      }

      // draw donut graph
      setDonutGraphOptions({
        ...donutGraphOptions,
        labels: donutLabelsTmp,
        colors: donutColorsTmp,
      });
      setDonutGraphTips(donutTipsTmp);
      setDonutGraphData(donutDataTmp);

      /*
      // draw line graph
      setLineGraphOptions({
        ...lineGraphOptions,
        colors: Object.keys(config.networks).map((key: string) => config.networks[key].color),
      });
      setLineGraphData(
        Object.keys(config.networks).map((key: string) => {
          return {
            name: config.networks[key].name,
            data: config.networks[key].graphData,
          };
        }),
      );
      */

      setTop5ListFilter('gainers');

      let top5ListTmp = {};
      const sortable = [];
      for (const k in config.portfolio) {
        sortable.push([k, config.portfolio[k]]);
      }

      sortable.sort((a: any, b: any) =>
        parseFloat(b.pnl24hpercentage) > parseFloat(a.pnl24hpercentage) ? -1 : 1,
      );
      sortable.forEach((item: any): void => {
        top5ListTmp[item[0] as keyof Object] = { ...item[1] };
      });

      top5ListTmp = {
        ...Object.values(top5ListTmp).filter((item: any) => {
          if (hideMinimumToken === 0 || parseFloat(item.balance) > hideMinimumToken) return true;
        }),
      };

      top5ListTmp = {
        ...Object.values(top5ListTmp).filter((item: any) => {
          if (top5ListFilter === 'gainers') return parseFloat(item.pnl24hamount) > 0;
          else return parseFloat(item.pnl24hamount) < 0;
        }),
      };

      setTop5List(top5ListTmp);
      setNetworkFilter(Object.keys(config.globalNetworks));
    } else {
      renderShowTable({});
    }
    window.scrollTo(0, 1);

    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 10);

    if (document.getElementById('mobileSlider')) {
      setTimeout(() => {
        document.getElementById('mobileSlider')?.scroll({
          left: 50,
          behavior: 'smooth',
        });
      }, 200);
      setTimeout(() => {
        document.getElementById('mobileSlider')?.scroll({
          left: 60,
          behavior: 'smooth',
        });
      }, 210);
      setTimeout(() => {
        document.getElementById('mobileSlider')?.scroll({
          left: 70,
          behavior: 'smooth',
        });
      }, 220);

      setTimeout(() => {
        document?.getElementById('mobileSlider')?.scroll({
          left: 0,
          behavior: 'smooth',
        });
      }, 800);
    }
  }, [config.balance, config.globalNetworks]);

  useEffect(() => {
    if (config && config.networks) {
      // set table data
      const tmpData: any[] = [];
      Object.keys(config.networks).map((key: string) => {
        if (config.networks[key])
          Object.keys(config.networks[key]).map((k: string) => {
            if (config.networks[key][k].tokens && config.networks[key][k].tokens.length > 0)
              tmpData.push({
                network: config.networks[key][k].name,
                logo: config.networks[key][k].icon,
                wallet: key,
                balance:
                  config.networks[key][k].tokens &&
                  config.networks[key][k].tokens[0] &&
                  parseAmount(config.networks[key][k].tokens[0].amount, false, 2),
                mainBalance:
                  config.networks[key][k].tokens &&
                  config.networks[key][k].tokens[0] &&
                  parseMoney(config.networks[key][k].tokens[0].balance),
                mainBalanceRaw:
                  config.networks[key][k].tokens &&
                  config.networks[key][k].tokens[0] &&
                  parseMoney(config.networks[key][k].tokens[0].balance, true),
                /*volume:
                  config.networks[key][k].volume && parseMoney(config.networks[key][k].volume),*/
                fee: config.networks[key][k].fees && parseMoney(config.networks[key][k].fees.total),
                portfolio:
                  config.networks[key][k] &&
                  config.networks[key][k].balance &&
                  parseMoney(config.networks[key][k].balance),
                portfolioRaw:
                  config.networks[key][k] &&
                  config.networks[key][k].balance &&
                  parseMoney(config.networks[key][k].balance, true),
                pnl24: `${parseMoney(config.networks[key][k].pnlAmount)}(${parsePercentage(
                  config.networks[key][k].pnlRatio,
                )})`,
                pnl24amount: parseMoney(config.networks[key][k].pnlAmount),
                pnl24percentage: parsePercentage(config.networks[key][k].pnlRatio),
                tokenCount: config.networks[key][k].tokens && config.networks[key][k].tokens.length,
                ens:
                  k !== 'erc20'
                    ? '0'
                    : config.nftLoaded && nft && nft[key]
                    ? nft[key]['ens'].length.toString()
                    : '?',
                symbol:
                  config.networks[key][k].tokens &&
                  config.networks[key][k].tokens[0] &&
                  config.networks[key][k].tokens[0].symbol,
                nft:
                  config.nftLoaded && nft && nft[key] && nft[key][k]
                    ? nft[key][k].length.toString()
                    : '?',
                age: convertAge(config.networks[key][k]['age']),
                networkKey: k,
              });
          });
      });

      const myData = [
        ...tmpData.sort((a: any, b: any) =>
          parseFloat(b.portfolioRaw) > parseFloat(a.portfolioRaw) ? 1 : -1,
        ),
      ];
      setTableData(myData);
    }
  }, [config.nftLoaded]);

  useEffect(() => {
    let top5ListTmp = {};
    const sortable = [];
    if (gainerLoserFilter === 'portfolio') {
      for (const k in config.portfolio) {
        sortable.push([k, config.portfolio[k]]);
      }
    } else if (gainerLoserFilter === 'market') {
      for (const k in config.top10) {
        sortable.push([config.top10[k]['coingeckoid'], config.top10[k]]);
      }
    }

    if (top5ListFilter === 'gainers') {
      sortable.sort((a: any, b: any) => {
        return parseFloat(b[1].pnl24hpercentage) > parseFloat(a[1].pnl24hpercentage) ? 1 : -1;
      });
    } else {
      sortable.sort((a: any, b: any) =>
        parseFloat(b[1].pnl24hpercentage) > parseFloat(a[1].pnl24hpercentage) ? -1 : 1,
      );
    }
    sortable.forEach((item: any): void => {
      top5ListTmp[item[0] as keyof Object] = { ...item[1] };
    });

    top5ListTmp = {
      ...Object.values(top5ListTmp).filter((item: any) => {
        if (hideMinimumToken === 0 || parseFloat(item.balance) > hideMinimumToken) return true;
      }),
    };

    top5ListTmp = {
      ...Object.values(top5ListTmp).filter((item: any) => {
        if (top5ListFilter === 'gainers') return parseFloat(item.pnl24hamount) > 0;
        else return parseFloat(item.pnl24hamount) < 0;
      }),
    };
    setTop5List(top5ListTmp);
  }, [top5ListFilter, gainerLoserFilter]);

  const convertAge = (data: any): string => {
    const result: any = [];
    if (data) {
      if (data.years) {
        result.push(`${data.years}y`);
      }
      if (data.months) {
        result.push(`${data.months}m`);
      }
      if (data.days) {
        result.push(`${data.days}d`);
      }
    }
    return result.join(' ');
  };
  const renderShowTable = (data: any): void => {
    setShowTable(<DataTable columns={columns} data={data} />);
  };

  const columns = [
    {
      name: '',
      selector: (row: TableDataProps) => row.network,
      cell: (row: TableDataProps) => <CustomNetwork name={row.network} logo={row.logo} />,
      width: calculateColumnWidth('dashboard', 'icon'),
    },
    {
      name: '',
      selector: (row: TableDataProps) => row.wallet,
      cell: (row: TableDataProps) =>
        wallets.length > 1 ? <div className="wallet-name">{row.wallet}</div> : '',
      width: calculateColumnWidth('dashboard', 'wallet'),
    },
    {
      name: (
        <>
          Native Token
          <br />
          Balance
        </>
      ),
      selector: (row: TableDataProps) => row.balance,
      cell: (row: TableDataProps) => (
        <div className="table-main-token">
          <span>
            {row.balance} <span style={{ fontSize: '10px' }}>{row.symbol}</span>
          </span>
          <strong>{row.mainBalance}</strong>
        </div>
      ),
      width: calculateColumnWidth('dashboard', 'nativeBalance'),
    },
    {
      name: 'Portfolio ($)',
      selector: (row: TableDataProps) => row.portfolioRaw,
      sortable: true,
      width: calculateColumnWidth('dashboard', 'portfolio'),
      cell: (row: TableDataProps) => row.portfolio,
    },
    {
      name: 'PNL 24',
      selector: (row: TableDataProps) => row.pnl24,
      width: calculateColumnWidth('dashboard', '24h'),
      cell: (row: TableDataProps) => (
        <div
          className={`table-pnl-24 ${
            parseFloat(row.pnl24percentage) > 0
              ? 'green'
              : parseFloat(row.pnl24percentage) == 0
              ? ''
              : 'red'
          }`}
        >
          <span>{row.pnl24amount}</span>
          <strong>{row.pnl24percentage}</strong>
        </div>
      ),
    },
    {
      name: 'Tokens',
      selector: (row: TableDataProps) => row.tokenCount,
      sortable: true,
      cell: (row: TableDataProps) => (
        <Link className="insite-link" to={{ pathname: '/my-portfolio' }}>
          {row.tokenCount}
        </Link>
      ),
      width: calculateColumnWidth('dashboard', 'tokens'),
    },
    {
      name: 'NFT',
      selector: (row: TableDataProps) => row.nft,
      sortable: true,
      cell: (row: TableDataProps) => (
        <Link className="insite-link" to={{ pathname: '/nft-ens', state: { type: 'nft' } }}>
          {row.nft ? row.nft : 0}
        </Link>
      ),
      width: calculateColumnWidth('dashboard', 'nft'),
    },
    {
      name: 'ENS',
      selector: (row: TableDataProps) => row.ens,
      sortable: true,
      cell: (row: TableDataProps) => (
        <Link className="insite-link" to={{ pathname: '/nft-ens', state: { type: 'ens' } }}>
          {row.ens ? row.ens : 0}
        </Link>
      ),
      width: calculateColumnWidth('dashboard', 'ens'),
    },
    /*{
      name: 'Volume ($)',
      selector: (row: TableDataProps) => row.volume,
      width: '80px',
    },*/
    {
      name: 'Fee ($)',
      selector: (row: TableDataProps) => row.fee,
      width: calculateColumnWidth('dashboard', 'fee'),
    },
    {
      name: 'Age',
      selector: (row: TableDataProps) => row.age,
      width: calculateColumnWidth('dashboard', 'age'),
    },
  ];

  interface TableDataProps {
    network: string;
    logo: string;
    portfolio: string;
    portfolioRaw: number;
    wallet: string;
    balance: number;
    mainBalance: string;
    mainBalanceRaw: number;
    pnl24: string;
    pnl24amount: string;
    pnl24percentage: string;
    tokenCount: number;
    ens: string;
    nft: string;
    age: string;
    volume: string;
    fee: string;
    symbol: string;
    networkKey: string;
  }

  interface CustomNetworkProps {
    name: string;
    logo: string;
  }
  const CustomNetwork = (props: CustomNetworkProps) => {
    return (
      <div className={`icon-container-${theme}`}>
        <img src={props.logo} />
      </div>
    );
  };

  const setDataFilter = (networks?: string[], wallet?: string) => {
    let filteredData: any[] = [];
    if (networks) {
      filteredData = tableData.filter(item => {
        return networks ? networks.includes(item.networkKey) : true;
      });
    }
    if (wallet) {
      filteredData = filteredData.filter(item => {
        return wallet ? wallet === item.wallet : true;
      });
    }

    renderShowTable(filteredData);
  };

  useEffect(() => {
    setDataFilter(networkFilter, tableWalletFilter);
  }, [networkFilter, tableWalletFilter]);

  useEffect(() => {
    if (tableData) {
      renderShowTable(tableData);
      if (isMobile && document.getElementsByClassName('rdt_Table')[0]) {
        setTimeout(() => {
          document.getElementsByClassName('rdt_Table')[0].scroll({
            left: 50,
            behavior: 'smooth',
          });
        }, 200);
        setTimeout(() => {
          document.getElementsByClassName('rdt_Table')[0].scroll({
            left: 60,
            behavior: 'smooth',
          });
        }, 210);
        setTimeout(() => {
          document.getElementsByClassName('rdt_Table')[0].scroll({
            left: 70,
            behavior: 'smooth',
          });
        }, 220);

        setTimeout(() => {
          document.getElementsByClassName('rdt_Table')[0].scroll({
            left: 0,
            behavior: 'smooth',
          });
        }, 800);
      }
    }
  }, [tableData]);

  const top5ListChange = (value: string) => {
    setTop5ListFilter(value);
  };

  const tableWalletChange = (value: string) => {
    setTableWalletFilter(value);
  };

  const gainerLoserDropdown = (value: string) => {
    setGainerLoserFilter(value);
  };

  useEffect(() => {
    console.log('Demo Mode:', demoMode);
    if (demoMode) {
      setDonutGraphOptions({
        ...donutGraphOptions,
        labels: ['Ethereum', 'BSC', 'Polygon'],
        colors: ['#979695', '#f0b90c', '#8247e5'],
      });
      setDonutGraphTips(['Ethereum', 'BSC', 'Polygon']);
      setDonutGraphData([48, 36, 16]);

      const tmpData: any[] = [];

      tmpData.push({
        network: 'erc20',
        logo: '/icons/networks/erc20.png',
        wallet: 'Wallet',
        balance: parseAmount(65482),
        mainBalance: parseAmount(65482),
        mainBalanceRaw: parseMoney(2465, true),
        fee: parseMoney(1241),
        portfolio: parseMoney(41321),
        portfolioRaw: parseMoney(2465, true),
        pnl24: `${parseMoney(135)}(${parsePercentage(6.4)})`,
        pnl24amount: parseMoney(254),
        pnl24percentage: parsePercentage(6.4),
        tokenCount: 30,
        ens: 5,
        symbol: 'ETH',
        nft: 25,
        age: convertAge(564587),
        networkKey: 'erc20',
      });

      tmpData.push({
        network: 'bep20',
        logo: '/icons/networks/bep20.png',
        wallet: 'Wallet',
        balance: parseAmount(28965),
        mainBalance: parseAmount(28965),
        mainBalanceRaw: parseMoney(2465, true),
        fee: parseMoney(1241),
        portfolio: parseMoney(12459),
        portfolioRaw: parseMoney(2465, true),
        pnl24: `${parseMoney(135)}(${parsePercentage(6.4)})`,
        pnl24amount: parseMoney(254),
        pnl24percentage: parsePercentage(6.4),
        tokenCount: 24,
        ens: 0,
        symbol: 'BNB',
        nft: 52,
        age: convertAge(564587),
        networkKey: 'bep20',
      });

      tmpData.push({
        network: 'polygon',
        logo: '/icons/networks/polygon.png',
        wallet: 'Wallet',
        balance: parseAmount(5669),
        mainBalance: parseAmount(5669),
        mainBalanceRaw: parseMoney(2465, true),
        fee: parseMoney(1241),
        portfolio: parseMoney(5613),
        portfolioRaw: parseMoney(2465, true),
        pnl24: `${parseMoney(135)}(${parsePercentage(6.4)})`,
        pnl24amount: parseMoney(254),
        pnl24percentage: parsePercentage(6.4),
        tokenCount: 17,
        ens: 0,
        symbol: 'MATIC',
        nft: 16,
        age: convertAge(564587),
        networkKey: 'polygon',
      });

      setNetworkFilter(['erc20', 'bep20', 'polygon']);
      setTableData(tmpData);
    }
  }, [demoMode]);
  /*
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  // the required distance between touchStart and touchEnd to be detected as a swipe
  const minSwipeDistance = 50;

  const onTouchStart = e => {
    setTouchEnd(null); // otherwise the swipe is fired even with usual touch events
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = e => setTouchEnd(e.targetTouches[0].clientX);

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    if (isLeftSwipe) {
      moveRight();
    }
    if (isRightSwipe) {
      moveLeft();
    }
  };
  */

  const showTutorial = (name?: string) => {
    if (tutorialCount >= 1 && tutorialCount <= 9) {
    } else {
      if (demoMode && isMobile && tutorial === name) {
        setTutorial('');
        setTimeout(() => {
          document.getElementById('headerInputOverlay')?.click();
        }, 100);
      } else {
        setTutorial(name ? name : '');
      }
    }
  };

  const showHeaderSearch = () => {
    if (tutorialCount >= 1 && tutorialCount <= 9) {
    } else {
      if (demoMode) {
        setTutorial('');
        setTimeout(() => {
          document.getElementById('headerInputOverlay')?.click();
        }, 100);
      }
    }
  };

  useEffect(() => {
    if (systemReady) {
      if (demoMode && firstRun) setTutorialCount(1);
    }
  }, [systemReady]);

  useEffect(() => {
    if (firstRun) {
      if (isMobile) {
        if (tutorialCount === 1) {
          moveWidget1();
          setTutorial('walletInformation');
          setTimeout(() => {
            setTutorialCount(2);
          }, 1000);
        } else if (tutorialCount === 2) {
          moveWidget1();
          setTutorial('portfolioStats');
          setTimeout(() => {
            moveWidget1();
            setTutorialCount(3);
          }, 1000);
        } else if (tutorialCount === 3) {
          moveWidget3();
          setTutorial('topList');
          setTimeout(() => {
            setTutorialCount(4);
          }, 1000);
        } else if (tutorialCount === 4) {
          moveWidget1();
          setTutorial('menu');
          setTimeout(() => {
            setTutorialCount(5);
          }, 1000);
        } else if (tutorialCount === 5) {
          moveWidget1();
          setTutorial('table');
          setTimeout(() => {
            setTutorial('');
            setTutorialCount(6);
          }, 1000);
        }
      } else {
        if (tutorialCount === 1) {
          setTutorial('walletInformation');
          setTimeout(() => {
            setTutorialCount(2);
          }, 1000);
        } else if (tutorialCount === 2) {
          setTutorial('portfolioStats');
          setTimeout(() => {
            setTutorialCount(3);
          }, 1000);
        } else if (tutorialCount === 3) {
          setTutorial('menu');
          setTimeout(() => {
            setTutorialCount(4);
          }, 1000);
        } else if (tutorialCount === 4) {
          setTutorial('topList');
          setTimeout(() => {
            setTutorialCount(5);
          }, 1000);
        } else if (tutorialCount === 5) {
          setTutorial('table');
          setTimeout(() => {
            setTutorial('');
            setTutorialCount(6);
          }, 1000);
        }
      }
    }
  }, [tutorialCount]);

  return true ? (
    <>
      <div
        className={`dashboard d-flex justify-content-between mt-5 ${
          tutorialCount >= 1 && tutorialCount <= 9 ? 'noBlurHover' : ''
        }`}
      >
        <div className="widget-slider visible-m">
          <div className="left-arrow" id="leftArrow" onClick={moveLeft}></div>
          <div className="right-arrow" id="rightArrow" onClick={moveRight}></div>
        </div>
        {innerWidth < 1025 ? (
          <div
            className="mobile-slider"
            id="mobileSlider"
            /*
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
            */
          >
            <div
              ref={widgetRef1}
              onClick={() => {
                moveWidget1();
                showTutorial('walletInformation');
              }}
              onMouseLeave={() => {
                showTutorial('');
              }}
              className={`dashboard-widget small border-two-${theme} ${demoMode ? 'blur' : ''} ${
                tutorialCount === 1 ? 'activeHover' : ''
              }`}
            >
              <div className="dashboard-widget-title color-two title-big">WALLET INFORMATION</div>
              <div className="dashboard-widget--content">
                {true && (
                  <div className="dashboard-widget--chart-container radial">
                    <div className="chart-legend">
                      {Object.keys(donutGraphOptions!.labels!).map((key: any, index: number) => {
                        return (
                          <React.Fragment key={`k3-${index}`}>
                            {donutGraphOptions!.labels![key] === 'Others' ? (
                              <div className="legend-item">
                                <Tooltip
                                  className="tooltip"
                                  border="#ff6aff"
                                  background="var(--color-background-main)"
                                  color="var(--color-text-main)"
                                  content={donutGraphTips![key]}
                                  placement={'bottom'}
                                >
                                  <span
                                    style={{
                                      backgroundColor: `${donutGraphOptions!.colors![key]}`,
                                    }}
                                  />
                                  {donutGraphOptions!.labels![key]}
                                </Tooltip>
                              </div>
                            ) : (
                              <>
                                <div className="legend-item">
                                  <span
                                    style={{
                                      fontSize: true ? '10px' : 'initial',
                                      backgroundColor: `${donutGraphOptions!.colors![key]}`,
                                    }}
                                  />
                                  {donutGraphOptions!.labels![key]}
                                </div>
                              </>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </div>
                    <ReactApexChart
                      options={donutGraphOptions}
                      series={donutGraphData}
                      type="radialBar"
                      width={innerWidth > 1024 ? 220 : 160}
                    />
                  </div>
                )}
              </div>
              {demoMode && tutorial === 'walletInformation' && (
                <div className="demo-details mobile walletInformation">
                  <img src="/tutorial/arrow-2.svg" alt="" />
                  <div className="description">
                    The distribution of
                    <br />
                    the portfolio by
                    <br />
                    network is shown
                    <br />
                    here.
                  </div>
                </div>
              )}
            </div>
            <div
              ref={widgetRef2}
              onClick={() => {
                moveWidget1();
                showTutorial('portfolioStats');
              }}
              onMouseLeave={() => {
                showTutorial('');
              }}
              className={`dashboard-widget small border-three ${demoMode ? 'blur' : ''} ${
                tutorialCount === 2 ? 'activeHover' : ''
              }`}
            >
              <div className="dashboard-widget-title color-three title-big">PORTFOLIO STATS</div>
              <div className="dashboard-widget--content">
                <MyWalletData />
              </div>
              {demoMode && tutorial === 'portfolioStats' && (
                <div className="demo-details mobile portfolioStats">
                  <img src="/tutorial/arrow-2.svg" alt="" />
                  <div className="description">
                    Portfolio summary
                    <br />
                    is shown here.
                  </div>
                </div>
              )}
            </div>
            <div
              ref={widgetRef3}
              onClick={() => {
                moveWidget3();
                showTutorial('topList');
              }}
              onMouseLeave={() => {
                showTutorial('');
              }}
              className={`dashboard-widget full ${demoMode ? 'blur' : ''} ${
                tutorialCount === 3 ? 'activeHover' : ''
              }`}
            >
              {!demoMode && (
                <>
                  {config && top5List && (
                    <>
                      <div className="dashboard-widget-title color-five d-flex justify-content-end">
                        <div
                          id="hotGainer"
                          className="active"
                          onClick={(): void => {
                            document.getElementById('hotGainer')!.classList.add('active');
                            document.getElementById('hotLoser')!.classList.remove('active');
                            top5ListChange('gainers');
                          }}
                        >
                          Gainers
                        </div>
                        <div
                          id="hotLoser"
                          onClick={(): void => {
                            document.getElementById('hotLoser')!.classList.add('active');
                            document.getElementById('hotGainer')!.classList.remove('active');
                            top5ListChange('losers');
                          }}
                        >
                          Losers
                        </div>
                      </div>
                      <div className="dashboard-widget-title color-five d-flex gainerLoserDropdown">
                        <Dropdown
                          change={(value: string) => gainerLoserDropdown(value)}
                          color="white"
                          size="small"
                          label="Portfolio"
                        >
                          <div data-id="portfolio">Portfolio</div>
                          <div data-id="market">Market</div>
                        </Dropdown>
                      </div>
                    </>
                  )}
                  <div className={`dashboard-widget--list-container border-five-${theme}`}>
                    <div className="token-list">
                      {config &&
                        top5List &&
                        Object.values(top5List)
                          .slice(0, 5)
                          .map((item: any, index: number) => {
                            return (
                              <div key={index} className="token">
                                <img
                                  src={item.image ? item.image : item.logo}
                                  alt=""
                                  className="token-icon"
                                />
                                <div className="token-name">{item.name}</div>
                                <div className="token-last-price">
                                  <div
                                    className={`pnlAmount ${
                                      parseFloat(item.pnl24hamount) > 0
                                        ? 'up'
                                        : parseFloat(item.pnl24hamount) < 0
                                        ? 'down'
                                        : 'nochange'
                                    }`}
                                  >
                                    {parseMoney(
                                      parseFloat(item.price) + parseFloat(item.pnl24hamount),
                                    )}
                                  </div>
                                  <span>{parseMoney(item.price)}</span>
                                </div>
                                <div
                                  className={`token-percentage ${
                                    parseFloat(item.pnl24hpercentage) > 0
                                      ? 'up'
                                      : parseFloat(item.pnl24hpercentage) < 0
                                      ? 'down'
                                      : 'nochange'
                                  }`}
                                >
                                  {parsePercentage(item.pnl24hpercentage)}
                                </div>
                              </div>
                            );
                          })}

                      {config &&
                        top5List &&
                        Object.values(top5List).length === 0 &&
                        top5ListFilter === 'gainers' && (
                          <div className="topListDetails">
                            <div className="text l">Not one of your best days.</div>
                            <img src="/images/menu/my-portfolio-down.png" alt="" />
                          </div>
                        )}
                      {config &&
                        top5List &&
                        Object.values(top5List).length === 0 &&
                        top5ListFilter === 'losers' && (
                          <div className="topListDetails">
                            <div className="text g">Totally a perfect day for your portfolio!</div>
                            <img src="/images/menu/my-portfolio-up.png" alt="" />
                          </div>
                        )}
                    </div>
                  </div>
                </>
              )}
              {demoMode && (
                <>
                  <div className="dashboard-widget-title color-five d-flex justify-content-end">
                    <div id="hotGainer" className="active">
                      Gainers
                    </div>
                    <div id="hotLoser">Losers</div>
                  </div>
                  <div className="dashboard-widget-title color-five d-flex gainerLoserDropdown">
                    <Dropdown
                      disabled={true}
                      change={() => {}}
                      color="white"
                      size="small"
                      label="Market"
                    >
                      <div data-id="market">Market</div>
                    </Dropdown>
                  </div>
                  <div className={`dashboard-widget--list-container border-five-${theme}`}>
                    <div className="token-list demoMode">
                      <div className="token">
                        <img
                          src={
                            'https://assets.coingecko.com/coins/images/12392/large/alliance_block_logo.jpg'
                          }
                          alt=""
                          className="token-icon"
                        />
                        <div className="token-name">Nexera</div>
                        <div className="token-last-price">
                          <div className={`pnlAmount up`}>{parseMoney(0.02)}</div>
                          <span>{parseMoney(0.54)}</span>
                        </div>
                        <div className={`token-percentage up`}>{parsePercentage(0.2)}</div>
                      </div>
                      <div className="token">
                        <img
                          src={
                            'https://assets.coingecko.com/coins/images/12392/large/alliance_block_logo.jpg'
                          }
                          alt=""
                          className="token-icon"
                        />
                        <div className="token-name">Nexera</div>
                        <div className="token-last-price">
                          <div className={`pnlAmount up`}>{parseMoney(0.02)}</div>
                          <span>{parseMoney(0.54)}</span>
                        </div>
                        <div className={`token-percentage up`}>{parsePercentage(0.2)}</div>
                      </div>
                      <div className="token">
                        <img
                          src={
                            'https://assets.coingecko.com/coins/images/12392/large/alliance_block_logo.jpg'
                          }
                          alt=""
                          className="token-icon"
                        />
                        <div className="token-name">Nexera</div>
                        <div className="token-last-price">
                          <div className={`pnlAmount up`}>{parseMoney(0.02)}</div>
                          <span>{parseMoney(0.54)}</span>
                        </div>
                        <div className={`token-percentage up`}>{parsePercentage(0.2)}</div>
                      </div>
                      <div className="token">
                        <img
                          src={
                            'https://assets.coingecko.com/coins/images/12392/large/alliance_block_logo.jpg'
                          }
                          alt=""
                          className="token-icon"
                        />
                        <div className="token-name">Nexera</div>
                        <div className="token-last-price">
                          <div className={`pnlAmount up`}>{parseMoney(0.02)}</div>
                          <span>{parseMoney(0.54)}</span>
                        </div>
                        <div className={`token-percentage up`}>{parsePercentage(0.2)}</div>
                      </div>
                      <div className="token">
                        <img
                          src={
                            'https://assets.coingecko.com/coins/images/12392/large/alliance_block_logo.jpg'
                          }
                          alt=""
                          className="token-icon"
                        />
                        <div className="token-name">Nexera</div>
                        <div className="token-last-price">
                          <div className={`pnlAmount up`}>{parseMoney(0.02)}</div>
                          <span>{parseMoney(0.54)}</span>
                        </div>
                        <div className={`token-percentage up`}>{parsePercentage(0.2)}</div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {demoMode && tutorial === 'topList' && (
                <div className="demo-details mobile topList">
                  <img src="/tutorial/arrow-2.svg" alt="" />
                  <div className="description">
                    Gainers and Losers
                    <br />
                    of the day among
                    <br />
                    portfolio tokens is
                    <br />
                    shown here
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <>
            <div
              onClick={() => {
                if (demoMode && !isMobile) {
                  showHeaderSearch();
                }
              }}
              onMouseMove={() => {
                showTutorial('walletInformation');
              }}
              onMouseLeave={() => {
                showTutorial();
              }}
              className={`dashboard-widget small border-two-${theme} ${
                tutorial === 'header' ? 'locked' : ''
              } ${tutorial === 'header' ? 'locked' : ''} ${
                demoMode === true ? 'blur wallet-information' : ''
              } ${tutorialCount === 1 ? 'activeHover' : ''}`}
            >
              <div className="dashboard-widget-title color-two title-big">WALLET INFORMATION</div>
              <div className="dashboard-widget--content">
                <div className="dashboard-widget--chart-container radial">
                  {true && (
                    <div>
                      <div className="chart-legend">
                        {Object.keys(donutGraphOptions!.labels!).map((key: any, index: number) => {
                          return (
                            <React.Fragment key={`k3-${index}`}>
                              {donutGraphOptions!.labels![key] === 'Others' ? (
                                <div className="legend-item">
                                  <Tooltip
                                    className="tooltip"
                                    border="#ff6aff"
                                    background="var(--color-background-main)"
                                    color="var(--color-text-main)"
                                    content={donutGraphTips![key]}
                                    placement={'bottom'}
                                  >
                                    <span
                                      style={{
                                        backgroundColor: `${donutGraphOptions!.colors![key]}`,
                                      }}
                                    />
                                    {donutGraphOptions!.labels![key]}
                                  </Tooltip>
                                </div>
                              ) : (
                                <>
                                  <div className="legend-item">
                                    <span
                                      style={{
                                        fontSize: true ? '10px' : 'initial',
                                        backgroundColor: `${donutGraphOptions!.colors![key]}`,
                                      }}
                                    />
                                    {donutGraphOptions!.labels![key]}
                                  </div>
                                </>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </div>
                      <ReactApexChart
                        options={donutGraphOptions}
                        series={donutGraphData}
                        type="radialBar"
                        width={innerWidth > 1024 ? 220 : 160}
                      />
                    </div>
                  )}
                </div>
              </div>
              {demoMode && tutorial === 'walletInformation' && (
                <div className="demo-details walletInformation">
                  <img src="/tutorial/arrow-2.svg" alt="" />
                  <div className="description">
                    The distribution of
                    <br />
                    the portfolio by
                    <br />
                    network is shown
                    <br />
                    here.
                  </div>
                </div>
              )}
            </div>

            <div
              onClick={() => {
                if (demoMode && !isMobile) {
                  showHeaderSearch();
                }
              }}
              onMouseMove={() => {
                showTutorial('portfolioStats');
              }}
              onMouseLeave={() => {
                showTutorial();
              }}
              className={`dashboard-widget small border-three ${
                tutorial === 'header' ? 'locked' : ''
              } ${demoMode ? 'blur' : ''}
              ${tutorialCount === 2 ? 'activeHover' : ''}`}
            >
              <div className="dashboard-widget-title color-three title-big">PORTFOLIO STATS</div>
              <div className="dashboard-widget--content">
                <MyWalletData />
              </div>
              {demoMode && tutorial === 'portfolioStats' && (
                <div className="demo-details portfolioStats">
                  <img src="/tutorial/arrow-2.svg" alt="" />
                  <div className="description">
                    Portfolio summary
                    <br />
                    is shown here.
                  </div>
                </div>
              )}
            </div>
          </>
        )}

        <div
          onClick={() => {
            if (demoMode && !isMobile) {
              showHeaderSearch();
            }
          }}
          onMouseMove={() => {
            showTutorial('menu');
          }}
          onMouseLeave={() => {
            showTutorial();
          }}
          className={`dashboard-widget ${tutorial === 'header' ? 'locked' : ''} ${
            demoMode ? 'blur main-menu' : ''
          }
              ${
                (isMobile && tutorialCount === 4) || (!isMobile && tutorialCount === 3)
                  ? 'activeHover'
                  : ''
              }`}
        >
          <div className="dashboard-widget--main-links">
            <BigMenu />
          </div>
          {demoMode && tutorial === 'menu' && (
            <div className="demo-details menu">
              <img src="/tutorial/arrow.svg" alt="" />
              <div className="description">
                Specially illustrated
                <br />
                features can be
                <br />
                reached from here
              </div>
            </div>
          )}
        </div>
      </div>

      <div
        className={`dashboard d-flex justify-content-between mt-3 ${
          tutorialCount >= 1 && tutorialCount <= 9 ? 'noBlurHover' : ''
        }`}
      >
        <div
          onClick={() => {
            if (demoMode && !isMobile) {
              showHeaderSearch();
            }
          }}
          onMouseMove={() => {
            showTutorial('topList');
          }}
          onMouseLeave={() => {
            showTutorial();
          }}
          className={`dashboard-widget smaller hidden-m ${tutorial === 'header' ? 'locked' : ''} ${
            demoMode ? 'blur' : ''
          }
              ${tutorialCount === 4 ? 'activeHover' : ''}`}
        >
          {!demoMode && (
            <>
              {config && top5List && (
                <>
                  <div className="dashboard-widget-title color-five d-flex justify-content-end">
                    <div
                      id="hotGainer"
                      className="active"
                      onClick={(): void => {
                        document.getElementById('hotGainer')!.classList.add('active');
                        document.getElementById('hotLoser')!.classList.remove('active');
                        top5ListChange('gainers');
                      }}
                    >
                      Gainers
                    </div>
                    <div
                      id="hotLoser"
                      onClick={(): void => {
                        document.getElementById('hotLoser')!.classList.add('active');
                        document.getElementById('hotGainer')!.classList.remove('active');
                        top5ListChange('losers');
                      }}
                    >
                      Losers
                    </div>
                  </div>
                  <div className="dashboard-widget-title color-five d-flex gainerLoserDropdown">
                    <Dropdown
                      change={(value: string) => gainerLoserDropdown(value)}
                      color="white"
                      size="small"
                      label="Portfolio"
                    >
                      <div data-id="portfolio">Portfolio</div>
                      <div data-id="market">Market</div>
                    </Dropdown>
                  </div>
                </>
              )}
              <div className={`dashboard-widget--list-container border-five-${theme} mt-5`}>
                <div className="token-list">
                  {config &&
                    top5List &&
                    Object.values(top5List)
                      .slice(0, 5)
                      .map((item: any, index: number) => {
                        return (
                          <div key={index} className="token">
                            <img
                              src={item.image ? item.image : item.logo}
                              alt=""
                              className="token-icon"
                            />
                            <div className="token-name">{item.name}</div>
                            <div className="token-last-price">
                              <div
                                className={`pnlAmount ${
                                  parseFloat(item.pnl24hamount) > 0
                                    ? 'up'
                                    : parseFloat(item.pnl24hamount) < 0
                                    ? 'down'
                                    : 'nochange'
                                }`}
                              >
                                {parseMoney(parseFloat(item.price) + parseFloat(item.pnl24hamount))}
                              </div>
                              <span>{parseMoney(item.price)}</span>
                            </div>
                            <div
                              className={`token-percentage ${
                                parseFloat(item.pnl24hpercentage) > 0
                                  ? 'up'
                                  : parseFloat(item.pnl24hpercentage) < 0
                                  ? 'down'
                                  : 'nochange'
                              }`}
                            >
                              {parsePercentage(item.pnl24hpercentage)}
                            </div>
                          </div>
                        );
                      })}

                  {config &&
                    top5List &&
                    Object.values(top5List).length === 0 &&
                    top5ListFilter === 'gainers' && (
                      <div className="topListDetails">
                        <div className="text l">Not one of your best days.</div>
                        <img src="/images/menu/my-portfolio-down.png" alt="" />
                      </div>
                    )}
                  {config &&
                    top5List &&
                    Object.values(top5List).length === 0 &&
                    top5ListFilter === 'losers' && (
                      <div className="topListDetails">
                        <div className="text g">Totally a perfect day for your portfolio!</div>
                        <img src="/images/menu/my-portfolio-up.png" alt="" />
                      </div>
                    )}
                </div>
              </div>
            </>
          )}

          {demoMode && (
            <>
              <div className="dashboard-widget-title color-five d-flex justify-content-end">
                <div id="hotGainer" className="active">
                  Gainers
                </div>
                <div id="hotLoser">Losers</div>
              </div>
              <div className="dashboard-widget-title color-five d-flex gainerLoserDropdown">
                <Dropdown
                  disabled={true}
                  change={() => {}}
                  color="white"
                  size="small"
                  label="Market"
                >
                  <div data-id="market">Market</div>
                </Dropdown>
              </div>
              <div className={`dashboard-widget--list-container border-five-${theme} mt-5`}>
                <div className="token-list">
                  <div className="token">
                    <img
                      src={
                        'https://assets.coingecko.com/coins/images/12392/large/alliance_block_logo.jpg'
                      }
                      alt=""
                      className="token-icon"
                    />
                    <div className="token-name">AllianceBlock</div>
                    <div className="token-last-price">
                      <div className={`pnlAmount up`}>{parseMoney(0.02)}</div>
                      <span>{parseMoney(0.54)}</span>
                    </div>
                    <div className={`token-percentage up`}>{parsePercentage(0.2)}</div>
                  </div>
                </div>
              </div>
            </>
          )}
          {demoMode && tutorial === 'topList' && (
            <div className="demo-details topList">
              <img src="/tutorial/arrow-2.svg" alt="" />
              <div className="description">
                Gainers and Losers
                <br />
                of the day among
                <br />
                portfolio tokens is
                <br />
                shown here
              </div>
            </div>
          )}
        </div>

        <div
          onClick={() => {
            if (demoMode && !isMobile) {
              showHeaderSearch();
            }
          }}
          onMouseMove={() => {
            showTutorial('table');
          }}
          onMouseLeave={() => {
            showTutorial();
          }}
          className={`dashboard-widget bigger  ${tutorial === 'header' ? 'locked' : ''} ${
            demoMode ? 'blur table' : ''
          }
              ${tutorialCount === 5 ? 'activeHover' : ''}`}
        >
          <div className={`dashboard-widget--table-container `}>
            <div className={`network-selectors-${theme} `} id="network-selectors">
              <div
                className={`allFilter active`}
                id="allFilterItem"
                onClick={(): void => {
                  const items: any = document.getElementById('network-selectors');

                  for (let i = 0; i < items.children.length; i++) {
                    items.children[i].classList.remove('active');
                  }

                  document.getElementById('allFilterItem')!.classList.add('active');
                  setDataFilter([
                    'erc20',
                    'bep20',
                    'polygon',
                    'avalanche',
                    'moonbeam',
                    'moonriver',
                    'mantle',
                  ]);
                }}
              >
                <img className="activeImage" src="icons/networks/all.png" alt="" />
                <img className="normal" src="icons/networks/all.png" alt="" />
              </div>
              {!demoMode &&
                config.globalNetworks &&
                tableData &&
                Object.keys(config.globalNetworks).map((index: any) => {
                  return (
                    <div
                      key={`${index}`}
                      data-id={index}
                      className={`${config.globalNetworks[index].balance === 0 ? 'disabled' : ''}`}
                    >
                      <img
                        className="activeImage"
                        onClick={(e: any): void => {
                          if (config.globalNetworks[index].balance > 0) {
                            const items: any = document.getElementById('network-selectors');
                            const newValues: string[] = [];

                            for (let i = 0; i < items.children.length; i++) {
                              items.children[i].classList.remove('active');
                            }
                            newValues.push(e.target.parentNode.getAttribute('data-id'));
                            e.target.parentNode.classList.add('active');
                            setNetworkFilter(newValues);
                          }
                        }}
                        src={config.globalNetworks[index].icon}
                      />

                      <img
                        className="normal"
                        onClick={(e: any): void => {
                          if (config.globalNetworks[index].balance > 0) {
                            const items: any = document.getElementById('network-selectors');
                            const newValues: string[] = [];

                            for (let i = 0; i < items.children.length; i++) {
                              items.children[i].classList.remove('active');
                            }
                            newValues.push(e.target.parentNode.getAttribute('data-id'));
                            e.target.parentNode.classList.add('active');
                            setNetworkFilter(newValues);
                          }
                        }}
                        src={config.globalNetworks[index].icon}
                      />
                    </div>
                  );
                })}

              {demoMode && (
                <>
                  <div className="networkSelector">
                    <img src="/icons/networks/erc20.png" alt="" />
                  </div>
                  <div className="networkSelector">
                    <img src="/icons/networks/bep20.png" alt="" />
                  </div>
                  <div className="networkSelector">
                    <img src="/icons/networks/polygon.png" alt="" />
                  </div>
                  <div className="networkSelector">
                    <img src="/icons/networks/avalanche.png" alt="" />
                  </div>
                  <div className="networkSelector">
                    <img src="/icons/networks/moonbeam.png" alt="" />
                  </div>
                  <div className="networkSelector">
                    <img src="/icons/networks/moonriver.png" alt="" />
                  </div>
                </>
              )}
              {!isMobile && account && wallets && wallets.length > 1 && (
                <div className="table-wallet-filter">
                  <Dropdown
                    change={(value: string) => tableWalletChange(value)}
                    color="white"
                    size="small"
                    label="All Wallets"
                  >
                    <div key={`table-wallet-all`}>All Wallets</div>
                    {wallets &&
                      wallets.map((item: any, index: number) => {
                        return (
                          <div key={`table-wallet-${index}`} data-id={item.name}>
                            {item.name}
                          </div>
                        );
                      })}
                  </Dropdown>
                </div>
              )}
            </div>
            {isMobile && account && wallets && wallets.length > 1 && (
              <div className="table-wallet-filter mobile">
                <Dropdown
                  change={(value: string) => tableWalletChange(value)}
                  color="white"
                  size="small"
                  label="All Wallets"
                >
                  <div key={`table-wallet-all`}>All Wallets</div>
                  {wallets &&
                    wallets.map((item: any, index: number) => {
                      return (
                        <div key={`table-wallet-${index}`} data-id={item.name}>
                          {item.name}
                        </div>
                      );
                    })}
                </Dropdown>
              </div>
            )}

            <div className={`table-border-top-${theme}`} />
            {showTable}
            <div className={`table-border-bottom-${theme}`} />
          </div>
          {demoMode && tutorial === 'table' && (
            <>
              <div className={`demo-details table1 ${isMobile ? 'mobile' : ''}`}>
                <img src="/tutorial/arrow.svg" alt="" />
                <div className="description">
                  And you can filter your
                  <br />
                  portfolio summary
                  <br />
                  by network.
                </div>
              </div>
              <div className={`demo-details table2 ${isMobile ? 'mobile' : ''}`}>
                <img src="/tutorial/arrow.svg" alt="" />
                <div className="description">
                  You can filter your
                  <br />
                  portfolio summary
                  <br />
                  by wallet.
                </div>
              </div>
              <div className={`demo-details table3 ${isMobile ? 'mobile' : ''}`}>
                <img src={`/tutorial/${isMobile ? 'arrow' : 'arrow-2'}.svg`} alt="" />
                <div className="description">
                  You can see your portfolio
                  <br />
                  summary in the network
                  <br />
                  breakdown here.
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  ) : (
    <div style={{ minHeight: 'calc(100vh - 110px)' }} />
  );
}
